'use strict';

module.exports = require('./length')(require('./filter-map-slice-sorted')(
	require('./create')(Array)
));
